module.exports = "img { cursor: pointer; }\r\n"